require("../../node_modules/slick-carousel/slick/slick.js");

module.exports = {
  init: () => {
    $(".gallery-trigger").click(function() {
      if ($("body").hasClass("gallery--isactive")) {
        $("body").removeClass("gallery--isactive");
      } else {
        $("body").addClass("gallery--isactive");
        $(".gallery-thumbs").slick(
          "slickGoTo",
          $(".gallery").slick("slickCurrentSlide")
        );
        $("html,body").animate({ scrollTop: 0 }, 400);
        $("gallery-thumbs").removeClass("gallery-thumbs--hidden");
      }
      return false;
    });

    var lastScrollTop = 0;
    $(window).scroll(function() {
      var scrollTop = $(this).scrollTop();
      if (scrollTop > 200 && scrollTop > lastScrollTop) {
        $("body").removeClass("gallery--isactive");
      }
      lastScrollTop = scrollTop;
    });

    $(".gallery").slick({
      slide: ".gallery-slide",
      rows: 0,
      arrows: true,
      infinite: false,
      asNavFor: ".gallery-thumbs",
      prevArrow:
        "<div class='slick-prev'><i class='fal fa-chevron-left'></i></div>",
      nextArrow:
        "<div class='slick-next'><i class='fal fa-chevron-right'></i></div>"
    });

    $(".gallery-thumbs").slick({
      slide: ".gallery-thumbs-item",
      rows: 0,
      arrows: true,
      asNavFor: ".gallery",
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      centerMode: true,
      variableWidth: true,
      infinite: false,
      focusOnSelect: false,
      swipe: false,
      prevArrow:
        "<div class='slick-prev'><i class='fal fa-chevron-left'></i></div>",
      nextArrow:
        "<div class='slick-next'><i class='fal fa-chevron-right'></i></div>"
    });

    $(".gallery-thumbs-item").on("click", function(event) {
      $(".gallery-thumbs").slick("slickGoTo", $(this).data("slickIndex"));
    });

    var slides = $(".gallery .slick-track > .slick-slide").length;
    $(".gallery").on("afterChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      var inFocus = $(".gallery .slick-current").attr("data-slick-index");
      $(".gallery-thumbs .slick-current").removeClass("slick-current");
      $(
        '.gallery-thumbs .slick-slide[data-slick-index="' + inFocus + '"]'
      ).addClass("slick-current");
    });

    var isTouch = false;
    $("body").on("touchstart", function(e) {
      isTouch = true;
    });

    var timer;
    $(".gallery").on("mousemove touchstart", function(e) {
      $(".gallery-thumbs").removeClass("gallery-thumbs--hidden");
      clearTimeout(timer);
      timer = setTimeout(function() {
        if (
          $(".gallery-thumbs:hover, .gallery > .slick-arrow:hover").length ==
            0 ||
          isTouch == true
        ) {
          $(".gallery-thumbs").addClass("gallery-thumbs--hidden");
        }
      }, 4000);
    });

    $(document).on("keydown", function(e) {
      if ($("body").hasClass("gallery--isactive")) {
        if (e.keyCode == 37) {
          $(".gallery").slick("slickPrev");
        }
        if (e.keyCode == 39) {
          $(".gallery").slick("slickNext");
        }
      }
    });

    /* ########################
      Mobile browser fix for calculating correct vh
    ###########################*/

    if ($(".gallery").length) {
      function setHeightVarible() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", vh + "px");
      }

      setHeightVarible();
      window.addEventListener("resize", () => {
        setHeightVarible();
      });
    }
  }
};
